import { render, staticRenderFns } from "./Premiacoes.vue?vue&type=template&id=31a55666&scoped=true"
import script from "./Premiacoes.vue?vue&type=script&lang=js"
export * from "./Premiacoes.vue?vue&type=script&lang=js"
import style0 from "./Premiacoes.vue?vue&type=style&index=0&id=31a55666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a55666",
  null
  
)

export default component.exports